import React from 'react';
import ImgRes from '..//Assets/gallery7.JPG';
import ImgCom from '..//Assets/gallery11.jpg';
import ImgRep from '..//Assets/gallery9.JPG'
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/all';
gsap.registerPlugin(ScrollTrigger);

const Services = ({ isEnglish }) => {
	useGSAP(() => {
		const featuresAnimation = gsap.timeline({
			scrollTrigger: {
				trigger: '#services',
				start: 'top 95%',
				end: 'bottom 80%',
				toggleActions: 'play none none none',
				scrub: 3,
			},
		}); 
		featuresAnimation.fromTo(
			'.service__container',
			{
				x: '-50%',
				opacity: 0,
			},
			{
				x: '0%',
				stagger: 0.5,
				opacity: 1,
			}
		);
	},[isEnglish])
	return (
		<section id="services">
			<div className="container">
				<div className="row services__row">
					<header className="section__header">
						{isEnglish ? (
							<h4 className="section__title blue-text">
								SERVICES
							</h4>
						) : (
							<h4 className="section__title blue-text">
								SERVICOS
							</h4>
						)}
					</header>
					<div className="service__container">
						<div className="img__container left__img">
							<img className="res__img " src={ImgRes} alt="" />
						</div>
						<div className="sub-headers__container">
							{isEnglish ? (
								<div className="sub-headers">
									<h1 className="sub__header--title blue-text">
										Residential Glass
									</h1>
									<h3 className="section__header">
										Expert Residential Glass Solutions for
										Every Home
									</h3>
									<p>
										we specialize in high-quality
										residential glass solutions that bring
										beauty, safety, and energy efficiency to
										your home. From custom windows and
										sliding doors to shower enclosures and
										glass railings, our experienced team
										delivers expert craftsmanship and
										reliable service on every project.
									</p>
								</div>
							) : (
								<div className="sub-headers">
									<h1 className="sub__header--title blue-text">
										Vidrio Residencial
									</h1>
									<h3 className="section__header">
										Soluciones expertas en cristalería
										residencial para cada hogar.
									</h3>
									<p>
										nos especializamos en soluciones de
										vidrio residencial de alta calidad que
										aportan belleza, seguridad y eficiencia
										energética a tu hogar. Desde ventanas y
										puertas corredizas personalizadas hasta
										canceles de baño y barandales de vidrio,
										nuestro equipo experto ofrece mano de
										obra de confianza y servicio profesional
										en cada proyecto.
									</p>
								</div>
							)}
						</div>
					</div>
					<div className="service__container reverse">
						<div className="sub-headers__container">
							{isEnglish ? (
								<div className="sub-headers">
									<h1 className="sub__header--title blue-text">
										Commercial Glass
									</h1>
									<h3 className="section__header">
										Glass Solutions That Elevate Your
										Business
									</h3>
									<p>
										We bring clarity, style, and performance
										to every commercial project. Our glass
										solutions combine sleek aesthetics with
										superior functionality—perfect for
										modern offices, retail spaces, and
										architectural facades. Precision,
										safety, and craftsmanship are at the
										heart of everything we do.
									</p>
								</div>
							) : (
								<div className="sub-headers">
									<h1 className="sub__header--title blue-text">
										Vidrio Comercial
									</h1>
									<h3 className="section__header">
										Soluciones de vidrio que impulsan su
										negocio
									</h3>
									<p>
										Llevamos claridad, estilo y rendimiento
										a cada proyecto comercial. Nuestras
										soluciones de vidrio combinan una
										estética moderna con una funcionalidad
										superior, perfectas para oficinas
										contemporáneas, espacios comerciales y
										fachadas arquitectónicas. La precisión,
										la seguridad y la artesanía son el
										corazón de todo lo que hacemos.
									</p>
								</div>
							)}
						</div>
						<div className="img__container right__img">
							<img className="com__img " src={ImgCom} alt="" />
						</div>
					</div>
					<div className="service__container">
						<div className="img__container left__img">
							<img className="res__img " src={ImgRep} alt="" />
						</div>
						<div className="sub-headers__container">
							{isEnglish ? (
								<div className="sub-headers">
									<h1 className="sub__header--title blue-text">
										Repair & Replacement
									</h1>
									<h3 className="section__header">
										Seamless solutions to get your space
										back to normal.
									</h3>
									<p>
										Broken or damaged glass doesn't have to
										disrupt your day. Our expert repair and
										replacement services restore your home
										or business quickly, safely, and with
										lasting quality. We handle every job
										with care, precision, and attention to
										detail
									</p>
								</div>
							) : (
								<div className="sub-headers">
									<h1 className="sub__header--title blue-text">
										Reparación y Reemplazo
									</h1>
									<h3 className="section__header">
										Soluciones profesionales para que tu espacio vuelva a la normalidad.
									</h3>
									<p>
										El vidrio roto o dañado no tiene por qué
										interrumpir tu día. Nuestros servicios
										expertos de reparación y reemplazo
										restauran tu hogar o negocio de manera
										rápida, segura y con calidad duradera.
										Nos encargamos de cada trabajo con
										cuidado, precisión y atención al detalle
									</p>
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Services;
